

import { Injectable } from '@angular/core';
import { Department } from '@app/shared/models/admin/department';
import { HttpClientService } from 'app/core/http-client/http-client.service';
import { services } from 'app/core/settings';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ManageDriverRoleService {

  private static readonly endpoint = 'DriverRoles';
  constructor(private http: HttpClientService) { }

  list(body:any) {
    return this.http.post(body,`${ManageDriverRoleService.endpoint}/GetDriverRolesPaginatedList`, undefined, services.orderService)
  }

  getAllDriverRoles() {
    return this.http.get(`${ManageDriverRoleService.endpoint}/GetAllDriverRoles`, undefined, services.orderService)
  }
  
  create(model: Object): Observable<any> {
    return this.http.post(model, `${ManageDriverRoleService.endpoint}/Create`, undefined, services.orderService);
  }

  update(model: object): Observable<any> {
    return this.http.put(model, `${ManageDriverRoleService.endpoint}/Update`, services.orderService);
  }

  delete(id: number) {
    return this.http.delete<boolean>(`${ManageDriverRoleService.endpoint}/Delete/${id}`, undefined, services.orderService);
  }
}
